import { render, staticRenderFns } from "./IndividualCoursePage.vue?vue&type=template&id=48663d21&scoped=true"
import script from "./IndividualCoursePage.vue?vue&type=script&lang=js"
export * from "./IndividualCoursePage.vue?vue&type=script&lang=js"
import style0 from "./IndividualCoursePage.vue?vue&type=style&index=0&id=48663d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48663d21",
  null
  
)

export default component.exports